import React, {useState} from "react";
import {useSelector} from "react-redux";
import {
    useClearLastMonthBillingMutation,
    useFetchLastMonthBillingQuery,
} from "../../Apis/billingApi";
import {ownPermissionsSelector} from "../../Reducers/ownRoleReducer";
import styles from "./PaymentPendingBanner.module.css";

const PaymentPendingBanner = () => {
    const ownPermissions = useSelector(ownPermissionsSelector);
    const canReadBilling = ownPermissions?.canReadBilling();
    const canManagePayments = ownPermissions?.canManagePayments();
    const hasBillingPermission = canReadBilling && canManagePayments;
    const [paymentError, setPaymentError] = useState("");
    const {data: lastMonthBilling} = useFetchLastMonthBillingQuery(undefined, {
        skip: !hasBillingPermission,
    });
    const [clearLastMonthBilling, {isLoading}] = useClearLastMonthBillingMutation();

    if (!lastMonthBilling || lastMonthBilling.getIsPaid()) return null;

    const handlePayNow = async () => {
        setPaymentError("");
        try {
            const updatedBilling = await clearLastMonthBilling().unwrap();
            if (!updatedBilling.getIsPaid()) {
                setPaymentError("Payment failed. Please try again.");
            }
        } catch (error) {
            setPaymentError("Payment failed. Please try again.");
        }
    };

    return (
        <div className={styles.paymentBanner} role="alert">
            <div className={styles.paymentBannerContent}>
                <span>
                    Payment pending: We were unable to charge ${lastMonthBilling.getPendingAmount().toFixed(2)} bills failed for
                    last month&apos;s bill. Please pay now to avoid account disruption.
                </span>
                {paymentError && <span className={styles.paymentError}>{paymentError}</span>}
            </div>
            {canManagePayments && (
                <button
                    className={styles.payNowButton}
                    type="button"
                    disabled={isLoading}
                    onClick={handlePayNow}
                >
                    {isLoading ? "Paying..." : "Pay now"}
                </button>
            )}
        </div>
    );
};

export default PaymentPendingBanner;
